module.exports = __webpack_public_path__ + "3407ee08bbfd1bdd51aac25485fa2212.jpg";